@switch (model?.data?.pageType) {
<!-- blog post -->
@case ('blog-post') {
<cms-blog-page-post-view [model]="model">
</cms-blog-page-post-view>
}
<!-- blog category -->
@case ('blog-category') {
<cms-blog-page-category-view [model]="model">
</cms-blog-page-category-view>
}
<!-- blog category -->
@case ('blog-root') {
<cms-blog-page-root-view [model]="model">
</cms-blog-page-root-view>
}
<!-- standard page -->
@default {
<icms-outlet class="page-view-boundary"
             [components]="model.data.components"
             [name]="'Page components' ">
</icms-outlet>
}
}
